import { getDocumentPromotionStatus } from 'modules/FileManagerV2/api/promotionService';
import { PROMOTION_QUERY_KEY } from 'modules/FileManagerV2/constants/medicalRecordPromotion';

/**
 * @param {object} rowData
 * @returns {string|null}
 */
export const resolveFileManagerDocumentId = (rowData) => rowData?.file_id || rowData?.object_id || null;

/**
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {object} rowData
 * @returns {string}
 */
export const getCachedPromotionStatus = (queryClient, rowData) => {
  const fileId = resolveFileManagerDocumentId(rowData);
  if (!fileId) return 'not_promoted';

  const cached = queryClient.getQueryData([PROMOTION_QUERY_KEY, fileId]);
  return cached?.promotionStatus ?? rowData?.promotion_status ?? 'not_promoted';
};

/**
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {object} rowData
 * @param {string} firmUserId
 */
export const prefetchDocumentPromotionStatus = (queryClient, rowData, firmUserId) => {
  const fileId = resolveFileManagerDocumentId(rowData);
  if (!fileId || !firmUserId || rowData?.entry_type === 'folder') {
    return Promise.resolve();
  }

  return queryClient.prefetchQuery([PROMOTION_QUERY_KEY, fileId], () => getDocumentPromotionStatus({ fileId, firmUserId }), {
    staleTime: 30000,
  });
};

/**
 * @param {object} response
 * @param {object|null} selectedItem
 * @param {boolean} isVersionUpload
 * @returns {string[]}
 */
export const extractUploadedFileIds = (response, selectedItem, isVersionUpload) => {
  if (isVersionUpload && selectedItem) {
    const id = resolveFileManagerDocumentId(selectedItem);
    return id ? [id] : [];
  }

  const payload = response?.data?.data || response?.data || response || {};
  const uploaded = payload.file_folder || payload.files || payload.uploaded_files || [];

  if (Array.isArray(uploaded)) {
    return uploaded.map((file) => file.file_id || file.object_id).filter(Boolean);
  }

  if (payload.file_id) {
    return [payload.file_id];
  }

  return [];
};
